import { render, staticRenderFns } from "./EpsCard.vue?vue&type=template&id=53056bd2&scoped=true&"
import script from "./EpsCard.js?vue&type=script&lang=js&"
export * from "./EpsCard.js?vue&type=script&lang=js&"
import style0 from "./EpsCard.scss?vue&type=style&index=0&id=53056bd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53056bd2",
  null
  
)

export default component.exports